import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AboutMeService } from '../../services/about-me.service';
import { AboutMeQuestionComponent } from "./about-me-question/about-me-question.component";
import { SvgComponent } from '../../@core/components/svg/svg.component';

@Component({
  selector: 'app-about-me-walkthrough',
  standalone: true,
  imports: [CommonModule, TranslateModule, AboutMeQuestionComponent, AboutMeQuestionComponent, SvgComponent],
  templateUrl: './about-me-walkthrough.component.html',
  styleUrl: './about-me-walkthrough.component.scss'
})
export class AboutMeWalkthroughComponent implements OnInit {
  @Input() initialStep: number = -1;
  @Input() questions: any[] = [];
  @Output() close = new EventEmitter<void>();

  step = signal<number>(this.initialStep);

  constructor(private aboutMeService: AboutMeService) { }

  ngOnInit(): void {
    this.step.set(this.initialStep);
  }

  nextStep(event: any) {
    if (this.step() >= 0) {
      const isEditing = event.isEditing;
      if (isEditing) {
        this.aboutMeService.editAnswer(event.answer, event.answer.id).subscribe((response) => {
          this.questions[this.step()].answer = event.answer;
          this.step.set(this.step() + 1);
        });
      } else {
        this.aboutMeService.createAnswer(event.answer).subscribe((response) => {
          this.questions[this.step()].answer = event.answer;
          this.questions[this.step()].answer.id = response.id;
          this.step.set(this.step() + 1);
        });
      }
    } else {
      this.step.set(this.step() + 1);
    }
  }

  previousStep() {
    if (this.step() > 0) {
      this.step.set(this.step() - 1);
    }
  }
  closeDialog() {
    this.close.emit();
  }

  get currentStep() {
    return this.step();
  }

  get isLastStep() {
    return this.currentStep === this.questions.length;
  }
}
